import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "table-content" }
const _hoisted_4 = { class: "d-flex gap-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]

import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { ref } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { useShipOwnerCompanyStore } from "@/stores/master/ship-owner-company";
import { hasAccess } from "@/utils/helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListShipOwnerCompany',
  setup(__props) {

const linkAdd = {
  text: "Add Ship Owner Company",
  url: "/master/ship-owner-company/create",
};

const headers: Header[] = [
  { text: "NAME", value: "name" },
  { text: "ACTIONS", value: "action" },
];

const page = ref<number>(1);
const limit = ref<number>(10);
const totalItems = ref<number>(0);
const listOwners = ref<any>([]);
const shipOwnerCompanyStore = useShipOwnerCompanyStore();
const isLoading = ref(false);

const loadDataShipOwnerCompany = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await shipOwnerCompanyStore.dispatchGetList(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listOwners.value = await shipOwnerCompanyStore.owners.items;
    page.value = await shipOwnerCompanyStore.owners.page;
    limit.value = await shipOwnerCompanyStore.owners.pageSize;
    totalItems.value = await shipOwnerCompanyStore.owners.total;
  }
  isLoading.value = false;
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataShipOwnerCompany();
};

const handleEdit = (company: any) => {
  router.push("/master/ship-owner-company/" + company);
};

const handleDelete = async (company: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${company.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await shipOwnerCompanyStore.dispatchDelete(
          company.id
        );
        if (success) {
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
          loadDataShipOwnerCompany();
        } else {
          toast.error(message);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};

loadDataShipOwnerCompany();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "List Data Ship Owner Company")
      ], -1)),
      _createVNode(FilterTable, {
        link: linkAdd,
        onSearchByQuery: loadDataShipOwnerCompany
      }),
      _createElementVNode("div", _hoisted_3, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(BaseLoading, { key: 0 }))
          : _createCommentVNode("", true),
        (!isLoading.value)
          ? (_openBlock(), _createBlock(_unref(EasyDataTable), {
              key: 1,
              headers: headers,
              items: listOwners.value,
              "show-index": "",
              "server-options": {
            page: page.value,
            rowsPerPage: limit.value,
          },
              "server-items-length": totalItems.value,
              "onUpdate:serverOptions": handleServerOptionsUpdate,
              "buttons-pagination": ""
            }, {
              "item-action": _withCtx((props) => [
                _createElementVNode("div", _hoisted_4, [
                  (_unref(hasAccess)('ship_owner_company-update'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-info btn-sm text-white",
                        onClick: ($event: any) => (handleEdit(props.id))
                      }, " Edit ", 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  (_unref(hasAccess)('ship_owner_company-delete'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-danger btn-sm",
                        onClick: ($event: any) => (handleDelete(props))
                      }, " Delete ", 8, _hoisted_6))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["items", "server-options", "server-items-length"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})